








import Vue from 'vue'

/**
 * Paginator.
 */
export default Vue.extend({
  name: 'Paginator',
  data () {
    return {
      currentPage: this.value
    }
  },
  watch: {
    value: function () {
      this.currentPage = this.value
    }
  },
  computed: {
    isNextDisabled: function (): boolean {
      return this.currentPage >= this.pageAmount
    },
    isPrevDisabled: function (): boolean {
      return this.currentPage === 1
    }
  },
  methods: {
    /**
     * Gets called when the user clicks on the Prev button
     *
     * @remarks
     * Decreases the number of the current page and emit `input` event
     */
    goToPrev () {
      this.currentPage--
      this.$emit('input', this.currentPage)
    },
    /**
     * Gets called when the user clicks on the Next button
     *
     * @remarks
     * Increases the number of the current page and emit `input` event
     */
    goToNext () {
      this.currentPage++
      this.$emit('input', this.currentPage)
    }
  },
  props: [
    /**
     * Total of pages
     */
    'pageAmount',
    /**
     * Value of the component in the v-model
     */
    'value']
})
